import { champPath } from "./Static";
import styles from "./Background.module.css";

const Background = ({ cid = false, children }) => {
  if (cid === false) return <div className={styles.back}>{children}</div>;
  if (cid === 0)
    return (
      <div
        className={styles.back}
        style={{
          backgroundImage: `radial-gradient(630px at 53% -3%, rgba(0, 0, 0, 0.7) 0%, #000 99%, #000 100%), url(https://cdn5.xdx.gg/extrabg1200/front.webp)`,
        }}
      >
        {children}
      </div>
    );
  return (
    <div
      className={styles.back}
      style={{
        backgroundImage: `radial-gradient(630px at 53% -3%, rgba(0, 0, 0, 0.7) 0%, #000 99%, #000 100%),  url(https://cdn5.xdx.gg/champbg1215/${champPath(
          cid
        )}.webp)`,
      }}
    >
      {children}
    </div>
  );
};
export default Background;
